var _defs, _circle, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path6, _path7, _path8, _rect, _path9, _circle2, _path10, _path11, _ellipse5, _circle3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle4, _path24, _ellipse6, _ellipse7, _circle5, _circle6, _path25, _ellipse8, _ellipse9, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerSecureIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 1119.609,
    height: 699,
    viewBox: "0 0 1119.609 699",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5e25",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbf4a1",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5e25",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    gradientTransform: "scale(.8546 1.17013)",
    x1: 0.819,
    y1: 5.999,
    x2: 11.912,
    y2: 5.999,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    gradientTransform: "scale(.8546 1.17013)",
    x1: 0.819,
    y1: 5.999,
    x2: 11.912,
    y2: 5.999,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    gradientTransform: "scale(2.61274 .38274)",
    x1: 0.061,
    y1: 15.676,
    x2: 36.64,
    y2: 15.676,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    gradientTransform: "scale(2.61274 .38274)",
    x1: 0.061,
    y1: 15.676,
    x2: 36.64,
    y2: 15.676,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    gradientTransform: "scale(3.38127 .29575)",
    x1: 0.012,
    y1: 16.433,
    x2: 51.813,
    y2: 16.433,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    gradientTransform: "scale(3.38127 .29575)",
    x1: 0.012,
    y1: 16.433,
    x2: 51.813,
    y2: 16.433,
    gradientUnits: "userSpaceOnUse"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 292.609,
    cy: 213,
    r: 213,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.142c0 77.498 48.619 140.209 108.702 140.209",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.702 191.35c0-78.368 54.255-141.783 121.303-141.783m-190.62 8.601c0 73.614 31.003 133.183 69.317 133.183",
    fill: "#c5a963"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.702 191.35c0-100.137 62.71-181.167 140.208-181.167",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.834 192.34s15.415-.476 20.061-3.784 23.713-7.258 24.866-1.953 23.166 26.388 5.762 26.529-40.439-2.711-45.076-5.536-5.613-15.257-5.613-15.257Z",
    fill: "#a8a8a8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.834 211.285c-17.404.14-40.44-2.711-45.076-5.536-3.532-2.15-4.939-9.869-5.41-13.43-.326.014-.514.02-.514.02s.976 12.433 5.613 15.257 27.672 5.676 45.076 5.536c5.024-.04 6.76-1.828 6.664-4.476-.698 1.6-2.614 2.599-6.353 2.629Z",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.609,
    cy: 424.5,
    rx: 187,
    ry: 25.44,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.609,
    cy: 424.5,
    rx: 157,
    ry: 21.359,
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 836.609,
    cy: 660.5,
    rx: 283,
    ry: 38.5,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.609,
    cy: 645.5,
    rx: 170,
    ry: 23.127,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M462.61 626c90 23 263-30 282-90m-435-277s130-36 138 80-107 149-17 172m-246.599 26.283s39.073-10.82 41.477 24.045-32.16 44.783-5.11 51.695",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m778.706 563.24-7.878 50.295s-38.782 20.603-11.513 21.209 155.733 0 155.733 0 24.845 0-14.543-21.815l-7.878-52.719Z",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M753.83 634.198c6.192-5.51 16.998-11.252 16.998-11.252l7.878-50.295 113.921.107 7.878 49.582c9.185 5.087 14.875 8.987 18.203 11.978 5.06-1.154 10.587-5.443-18.203-21.389l-7.878-52.719-113.921 3.03-7.878 50.295s-32.588 17.315-16.999 20.663Z",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 578.433,
    y: 212.689,
    width: 513.253,
    height: 357.52,
    rx: 18.046,
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M595.703 231.777h478.713v267.837H595.703z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.059,
    cy: 223.293,
    r: 3.03,
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.687 520.822v31.34a18.043 18.043 0 0 1-18.046 18.046H596.48a18.043 18.043 0 0 1-18.045-18.045v-31.34ZM968.978 667.466v6.06h-326.01v-4.848l.449-1.212 8.035-21.815h310.86l6.666 21.815zm125.46-5.932c-.594 2.539-2.836 5.217-7.902 7.75-18.179 9.09-55.143-2.424-55.143-2.424s-28.48-4.848-28.48-17.573a22.725 22.725 0 0 1 2.496-1.485c7.643-4.043 32.985-14.02 77.918.423a18.74 18.74 0 0 1 8.541 5.597c1.821 2.132 3.249 4.835 2.57 7.712Z",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.438 661.534c-22.251 8.526-42.084 9.162-62.439-4.975-10.265-7.127-19.59-8.89-26.59-8.757 7.643-4.043 32.985-14.02 77.918.423a18.74 18.74 0 0 1 8.541 5.597c1.821 2.132 3.249 4.835 2.57 7.712Z",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1066.538,
    cy: 654.135,
    rx: 7.878,
    ry: 2.424,
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.059,
    cy: 545.667,
    r: 11.513,
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M968.978 667.466v6.06h-326.01v-4.848l.449-1.212h325.561z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M108.609 159h208v242h-208z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M87.609 135h250v86h-250zm0 102h250v86h-250zm0 102h250v86h-250z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    opacity: 0.4,
    d: "M271.609 150h16v16h-16z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    opacity: 0.8,
    d: "M294.609 150h16v16h-16z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    d: "M317.609 150h16v16h-16z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    opacity: 0.4,
    d: "M271.609 251h16v16h-16z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    opacity: 0.8,
    d: "M294.609 251h16v16h-16z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    d: "M317.609 251h16v16h-16z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    opacity: 0.4,
    d: "M271.609 352h16v16h-16z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    opacity: 0.8,
    d: "M294.609 352h16v16h-16z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5a963",
    d: "M317.609 352h16v16h-16z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.609,
    cy: 538,
    r: 79,
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M280.609 600h24v43h-24zm48 0h24v43h-24z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.609,
    cy: 643.5,
    rx: 20,
    ry: 7.5,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.609,
    cy: 642.5,
    rx: 20,
    ry: 7.5,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.609,
    cy: 518,
    r: 27,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.609,
    cy: 518,
    r: 9,
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M239.977 464.532c-6.379-28.567 14.012-57.434 45.544-64.474s62.265 10.41 68.644 38.977-14.518 39.104-46.05 46.145-61.759 7.92-68.138-20.648Z",
    fill: "#c5a963"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.215,
    cy: 611.344,
    rx: 39.5,
    ry: 12.4,
    transform: "rotate(-23.171 156.408 637.654)",
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.215,
    cy: 664.344,
    rx: 39.5,
    ry: 12.4,
    transform: "rotate(-23.171 8.408 690.654)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M362.61 561c0 7.732-19.909 23-42 23s-43-14.268-43-22 20.909-6 43-6 42-2.732 42 5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.18 14.56h-2.1V20h2.1zm-2.1 0v-2.08H.7V7.02h2.08v7.54zm0-2.08h2.1V7.02h-2.1zm-5.3 2.08H.7V20h2.08z",
    style: {
      fill: "url(#c)"
    },
    transform: "translate(761.87 154.265) scale(13.20185)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.16 6h3.48v4.62H2.9V6.74H.88v12.52H2.9V15.4h.74V20H.16Zm1.38 1.32h.72v3.92h6.1V6h.7v5.94H1.54Zm9.66-.58h-.68V12H9.8V6h2.1v14h-.7zm-2.84 8.02h-6.1v4.02h-.74v-4.76h7.54v5.24h.74v-5.9H1.52v-.7h9V20H8.36Zm9.025 4h.88l.7-1.68 5.22.02 1.28 2.9 3.68-.02L22.845 6h-1.28l-6.26 13.98h3.9l.68-1.6h3.98l-.3-.68h-4.12l-.64 1.58h-2.38l5.54-12.6h.48l5.56 12.6h-2.12l-1.28-2.86h-6.2zm2.38-3.52 2.44-5.82 4.1 9.32h.82l-4.92-10.96-3.6 8.08h5.8l-2.2-4.86-1.52 3.66h.78l.74-1.82 1.1 2.4zm9.725-8.5h2.26l3.48 7.24.42-.86L32.21 6h-3.9l6.74 14h.34l6.42-13.26h.7L36.07 20h.82l6.8-14h-2.34l-6.12 12.6Zm5.76 10.48L40.67 6h-.84l-4.58 9.52-3.94-8.14h-.82ZM47.275 6h2.1v12.66h-.72V6.72h-.66v12.56h2.02V6h.72v14h-3.46zm17.205 9.44c-1.26.82-1.88 1.06-2.74 1.06-.6 0-1.16-.16-1.7-.48-1.06-.64-1.78-1.8-1.78-3 0-.64.16-1.24.48-1.78.62-1.08 1.8-1.72 3-1.72.76 0 1.44.22 2.02.64.1.06.22.14.36.28l.3.22 1.34-1.58-.22-.22c-.14-.14-.32-.26-.54-.4-.94-.72-2.04-1.08-3.26-1.08-1.5 0-2.88.58-3.98 1.64-1.06 1.12-1.66 2.5-1.66 4s.6 2.92 1.66 3.98a5.616 5.616 0 0 0 3.98 1.66c1.08 0 2.08-.3 3.02-.9l-.4-.6c-.82.54-1.68.8-2.62.8-1.3 0-2.54-.52-3.48-1.46a4.887 4.887 0 0 1-1.44-3.48c0-1.3.5-2.52 1.44-3.46.94-.96 2.18-1.46 3.48-1.46.98 0 1.92.3 2.86.92l.16.14-.44.5a.322.322 0 0 1-.14-.08c-.74-.5-1.56-.76-2.44-.76-.78 0-1.48.18-2.1.54-1.26.74-2.1 2.2-2.1 3.66 0 .7.2 1.4.58 2.06.78 1.34 2.2 2.16 3.62 2.16.94 0 1.7-.28 2.84-1l1.12 1.66c-1.46.96-2.6 1.36-3.96 1.36-1.12 0-2.16-.28-3.12-.84-1.94-1.12-3.14-3.16-3.14-5.4 0-1.12.28-2.16.84-3.14a6.282 6.282 0 0 1 5.42-3.12c1.58 0 3.08.58 4.22 1.64l.12.1.16.16.5-.52-.28-.28a7.112 7.112 0 0 0-4.72-1.8c-1.26 0-2.42.3-3.48.92-2.12 1.22-3.5 3.56-3.5 6.04 0 1.22.32 2.38.96 3.46 1.26 2.16 3.52 3.52 6.02 3.52 1.58 0 2.9-.5 4.68-1.72l.28-.18-1.9-2.86ZM76.585 20c-1.94 0-3.42-.5-4.4-1.5-.96-.96-1.46-2.38-1.46-4.06V6.02h3.4v8.42c0 1.52.74 2.16 2.36 2.16 1.58 0 2.44-.78 2.44-2.16V6.02h2.06v8.42c0 1.06-.28 2.06-.82 2.78-.72.98-1.86 1.44-3.62 1.44-1.02 0-1.84-.14-2.46-.44-1.26-.58-2.02-1.88-2.02-3.78V7.3h.72v7.14c0 2.26 1.3 3.5 3.76 3.5s3.72-1.24 3.72-3.5v-7.7h-.62v7.7c0 1.76-1.18 2.88-3.16 2.88-2 0-3.06-1.02-3.06-2.88v-7.7h-1.98v7.7c0 3.18 1.76 4.84 5.14 4.84 1.76 0 2.96-.42 3.78-1.28.82-.86 1.26-2.1 1.26-3.56V6.02h.72v8.42c0 1.68-.52 3.08-1.48 4.06-.96 1-2.38 1.5-4.28 1.5zm11.725-3.3c.98.44 1.84.66 2.56.66.36 0 .58-.02.68-.08.46-.12.78-.38.98-.78l.02-.04c.1-.18.14-.4.14-.68 0-.14-.04-.3-.12-.5l-.04-.08c-.26-.54-.84-.9-1.9-1.24l-.2-.06-.06-.02c-1.62-.48-2.66-1.24-3.16-2.3-.2-.4-.3-.84-.3-1.32 0-.5.1-.98.3-1.48l.04-.08c.46-.92 1.2-1.52 2.18-1.82.7-.1 1.1-.16 1.2-.16 1.36 0 2.94.56 4.72 1.66l.38-.62C93.79 6.58 92.11 6 90.65 6c-.58 0-1.06.06-1.4.2-1.18.32-2.06 1.04-2.64 2.18l-.06.14a4.52 4.52 0 0 0-.36 1.74c0 .62.12 1.16.36 1.64.62 1.24 1.82 2.12 3.62 2.66l.24.08c.82.26 1.3.54 1.48.86l.02.04c.04.06.06.14.06.24 0 .18-.02.3-.08.4-.14.32-.48.48-1.02.48-.86 0-2.1-.44-3.06-1.06l-.3-.18-1.76 2.84.3.18c1.42.96 3.3 1.56 4.82 1.56.5 0 .96-.06 1.38-.18 1.18-.34 2.06-1.08 2.64-2.2l.08-.14c.24-.62.36-1.2.36-1.74 0-.48-.16-1.08-.46-1.82-.54-1.08-1.68-1.9-3.46-2.46l-.28-.08c-.56-.18-.94-.36-1.12-.5-.24-.2-.38-.34-.44-.42l-.04-.22c0-.2.04-.38.14-.52.16-.3.32-.38.96-.38.86 0 2.1.44 3.06 1.06l.3.18 1.08-1.72-.32-.18c-1.22-.8-2.88-1.36-4.1-1.36-.54 0-.88.04-1.06.14-.82.24-1.44.76-1.84 1.54-.18.34-.26.74-.26 1.24 0 .38.08.74.24 1.08.42.9 1.36 1.56 2.82 2l.26.08.54.2c.3.12.62.28.98.48.64.38.96.92.96 1.64 0 .4-.1.78-.28 1.12-.42.74-1.14 1.12-2.14 1.12-.68 0-1.64-.26-2.88-.76l-.34.58-.02.04c1.14.58 2.22.86 3.26.86.58 0 1.12-.12 1.6-.36.94-.46 1.52-1.42 1.52-2.62 0-1.9-1.46-2.46-3-3l-.26-.08c-1.26-.38-2.04-.9-2.36-1.6-.12-.24-.18-.5-.18-.8 0-.38.06-.68.2-.94.32-.58.78-.96 1.38-1.14l.8-.1c1.06 0 2.22.36 3.48 1.06l-.32.5c-1.3-.64-2.34-.96-3.1-.96-.38 0-.6.02-.7.08-.44.12-.76.38-.98.8l-.02.04c-.1.18-.14.42-.14.72 0 .22.04.38.1.48.26.54.94.98 2.02 1.3l.26.08.5.16c.06.02.38.16.96.44.78.44 1.34 1 1.66 1.66.2.4.3.84.3 1.32 0 .58-.1 1.08-.32 1.5l-.04.08c-.46.92-1.2 1.52-2.18 1.82-.7.1-1.1.16-1.2.16-1.02 0-2.34-.38-3.56-.96l-.56-.3 1-1.62z",
    style: {
      fill: "url(#e)"
    },
    transform: "matrix(2.14 0 0 2.14 731.707 416.79)",
    fill: "url(#SvgjsLinearGradient2723)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1 20.18c-.653 0-1.234-.087-1.74-.26a3.028 3.028 0 0 1-1.28-.83c-.347-.38-.603-.877-.77-1.49-.167-.613-.237-1.353-.21-2.22h1.2c0 .427.02.87.06 1.33.04.46.147.88.32 1.26.173.38.437.69.79.93.353.24.843.36 1.47.36.533 0 .987-.08 1.36-.24.373-.16.677-.373.91-.64a2.27 2.27 0 0 0 .49-.94c.093-.36.14-.733.14-1.12 0-.453-.083-.85-.25-1.19a3.28 3.28 0 0 0-.66-.91 4.598 4.598 0 0 0-.96-.71 9.601 9.601 0 0 0-1.15-.55c-.64-.253-1.2-.503-1.68-.75a4.676 4.676 0 0 1-1.18-.83 2.986 2.986 0 0 1-.69-1.07C.117 9.903.04 9.407.04 8.82c0-1.333.35-2.327 1.05-2.98.7-.653 1.703-.98 3.01-.98 1.133 0 2.03.33 2.69.99.66.66.99 1.65.99 2.97v1.1H6.66v-1.2c0-.413-.05-.797-.15-1.15a2.606 2.606 0 0 0-.47-.93 2.237 2.237 0 0 0-.81-.63c-.327-.153-.717-.23-1.17-.23-1.067 0-1.83.28-2.29.84-.46.56-.67 1.313-.63 2.26.013.413.09.767.23 1.06.14.293.327.55.56.77.233.22.513.417.84.59.327.173.69.347 1.09.52.467.2.93.413 1.39.64.46.227.89.507 1.29.84.4.347.73.75.99 1.21.26.46.39 1.03.39 1.71 0 1.32-.337 2.31-1.01 2.97-.673.66-1.61.99-2.81.99zm10.062 0c-2.52 0-3.78-1.32-3.78-3.96v-7.4c0-1.333.317-2.327.95-2.98s1.657-.98 3.07-.98c1.293 0 2.25.33 2.87.99.62.66.93 1.637.93 2.93v7.44c0 .667-.07 1.247-.21 1.74-.14.493-.37.907-.69 1.24-.32.333-.737.58-1.25.74-.513.16-1.143.24-1.89.24zm2.98-11.42c0-.333-.047-.673-.14-1.02a2.794 2.794 0 0 0-.46-.95 2.39 2.39 0 0 0-.85-.7c-.353-.18-.79-.27-1.31-.27-.573 0-1.05.08-1.43.24-.38.16-.68.383-.9.67-.22.287-.377.623-.47 1.01-.093.387-.14.807-.14 1.26v7.1c0 .347.04.7.12 1.06.08.36.223.69.43.99.207.3.487.547.84.74.353.193.797.29 1.33.29.573 0 1.05-.077 1.43-.23.38-.153.683-.363.91-.63.227-.267.39-.583.49-.95.1-.367.15-.763.15-1.19V8.76zm4.802-2.62v6.06h6.02v1.06h-6.02V20h-1.16V5h7.28v1.14Zm12.822-.04V20h-1.16V6.1h-3.26V5h7.68v1.1ZM51.048 20h-.98l-2.74-13.4-2.72 13.4h-.96l-3.44-15h1.06l2.74 13.08L47.028 5h.64l3 13.08L53.408 5h1.08zm12.002 0-1.1-4.42h-4.88L55.97 20h-1l4.14-15h.86l4.12 15zM59.57 5.94l-2.26 8.68h4.38zM73.692 20l-3.3-6.22h-3.06V20h-.98V5h3.4c.787 0 1.46.117 2.02.35.56.233 1.02.55 1.38.95.36.4.627.863.8 1.39.173.527.26 1.077.26 1.65 0 .973-.25 1.85-.75 2.63a4.44 4.44 0 0 1-1.97 1.71l3.52 6.32zm-4.08-14.08h-2.28v6.84h2.42c.68 0 1.24-.103 1.68-.31.44-.207.783-.473 1.03-.8.247-.327.42-.7.52-1.12.1-.42.15-.85.15-1.29 0-.467-.08-.9-.24-1.3a3.093 3.093 0 0 0-1.79-1.76c-.433-.173-.93-.26-1.49-.26zM77.454 20V5h7.36v1.16h-6.32v5.7h6.26v.92h-6.26v6.06h6.46V20Zm18.704.18c-.653 0-1.234-.087-1.74-.26a3.028 3.028 0 0 1-1.28-.83c-.347-.38-.603-.877-.77-1.49-.167-.613-.237-1.353-.21-2.22h1.2c0 .427.02.87.06 1.33.04.46.147.88.32 1.26.173.38.437.69.79.93.353.24.843.36 1.47.36.533 0 .987-.08 1.36-.24.373-.16.677-.373.91-.64a2.27 2.27 0 0 0 .49-.94c.093-.36.14-.733.14-1.12 0-.453-.083-.85-.25-1.19a3.28 3.28 0 0 0-.66-.91 4.598 4.598 0 0 0-.96-.71 9.601 9.601 0 0 0-1.15-.55c-.64-.253-1.2-.503-1.68-.75a4.676 4.676 0 0 1-1.18-.83 2.986 2.986 0 0 1-.69-1.07c-.153-.407-.23-.903-.23-1.49 0-1.333.35-2.327 1.05-2.98.7-.653 1.703-.98 3.01-.98 1.133 0 2.03.33 2.69.99.66.66.99 1.65.99 2.97v1.1h-1.12v-1.2c0-.413-.05-.797-.15-1.15a2.606 2.606 0 0 0-.47-.93 2.237 2.237 0 0 0-.81-.63c-.327-.153-.717-.23-1.17-.23-1.067 0-1.83.28-2.29.84-.46.56-.67 1.313-.63 2.26.013.413.09.767.23 1.06.14.293.327.55.56.77.233.22.513.417.84.59.327.173.69.347 1.09.52.467.2.93.413 1.39.64.46.227.89.507 1.29.84.4.347.73.75.99 1.21.26.46.39 1.03.39 1.71 0 1.32-.337 2.31-1.01 2.97-.673.66-1.61.99-2.81.99zm10.062 0c-2.52 0-3.78-1.32-3.78-3.96v-7.4c0-1.333.317-2.327.95-2.98s1.657-.98 3.07-.98c1.293 0 2.25.33 2.87.99.62.66.93 1.637.93 2.93v7.44c0 .667-.07 1.247-.21 1.74-.14.493-.37.907-.69 1.24-.32.333-.737.58-1.25.74-.513.16-1.143.24-1.89.24zm2.98-11.42a3.91 3.91 0 0 0-.14-1.02 2.793 2.793 0 0 0-.46-.95 2.39 2.39 0 0 0-.85-.7c-.353-.18-.79-.27-1.31-.27-.573 0-1.05.08-1.43.24-.38.16-.68.383-.9.67-.22.287-.377.623-.47 1.01-.093.387-.14.807-.14 1.26v7.1c0 .347.04.7.12 1.06.08.36.223.69.43.99.207.3.487.547.84.74.353.193.797.29 1.33.29.573 0 1.05-.077 1.43-.23.38-.153.683-.363.91-.63.227-.267.39-.583.49-.95.1-.367.15-.763.15-1.19V8.76zM113.042 20V5h1.08v13.92h5.1V20Zm11.762.18c-1.227 0-2.177-.333-2.85-1s-1.01-1.653-1.01-2.96V5h1.08v11.16c0 .32.043.657.13 1.01.087.353.237.673.45.96.213.287.497.523.85.71.353.187.79.28 1.31.28.573 0 1.047-.083 1.42-.25.373-.167.673-.397.9-.69.227-.293.387-.64.48-1.04.093-.4.14-.827.14-1.28V5h1.06v11.22c0 1.333-.323 2.327-.97 2.98s-1.643.98-2.99.98zM135.466 6.1V20h-1.16V6.1h-3.26V5h7.68v1.1Zm5.782 13.9V5h1.28v15zm8.222.18c-2.52 0-3.78-1.32-3.78-3.96v-7.4c0-1.333.317-2.327.95-2.98s1.657-.98 3.07-.98c1.293 0 2.25.33 2.87.99.62.66.93 1.637.93 2.93v7.44c0 .667-.07 1.247-.21 1.74-.14.493-.37.907-.69 1.24-.32.333-.737.58-1.25.74-.513.16-1.143.24-1.89.24zm2.98-11.42a3.91 3.91 0 0 0-.14-1.02 2.793 2.793 0 0 0-.46-.95 2.39 2.39 0 0 0-.85-.7c-.353-.18-.79-.27-1.31-.27-.573 0-1.05.08-1.43.24-.38.16-.68.383-.9.67-.22.287-.377.623-.47 1.01-.093.387-.14.807-.14 1.26v7.1c0 .347.04.7.12 1.06.08.36.223.69.43.99.207.3.487.547.84.74.353.193.797.29 1.33.29.573 0 1.05-.077 1.43-.23.38-.153.683-.363.91-.63.227-.267.39-.583.49-.95.1-.367.15-.763.15-1.19V8.76zM163.192 20l-5.8-12.88V20h-1.1V5h1.18l5.8 12.3.14-12.3h1.08v15zm8.182.18c-.653 0-1.234-.087-1.74-.26a3.028 3.028 0 0 1-1.28-.83c-.347-.38-.603-.877-.77-1.49-.167-.613-.237-1.353-.21-2.22h1.2c0 .427.02.87.06 1.33.04.46.147.88.32 1.26.173.38.437.69.79.93.353.24.843.36 1.47.36.533 0 .987-.08 1.36-.24.373-.16.677-.373.91-.64a2.27 2.27 0 0 0 .49-.94c.093-.36.14-.733.14-1.12 0-.453-.083-.85-.25-1.19a3.28 3.28 0 0 0-.66-.91 4.598 4.598 0 0 0-.96-.71 9.601 9.601 0 0 0-1.15-.55c-.64-.253-1.2-.503-1.68-.75a4.676 4.676 0 0 1-1.18-.83 2.986 2.986 0 0 1-.69-1.07c-.153-.407-.23-.903-.23-1.49 0-1.333.35-2.327 1.05-2.98.7-.653 1.703-.98 3.01-.98 1.133 0 2.03.33 2.69.99.66.66.99 1.65.99 2.97v1.1h-1.12v-1.2c0-.413-.05-.797-.15-1.15a2.606 2.606 0 0 0-.47-.93 2.237 2.237 0 0 0-.81-.63c-.327-.153-.717-.23-1.17-.23-1.067 0-1.83.28-2.29.84-.46.56-.67 1.313-.63 2.26.013.413.09.767.23 1.06.14.293.327.55.56.77.233.22.513.417.84.59.327.173.69.347 1.09.52.467.2.93.413 1.39.64.46.227.89.507 1.29.84.4.347.73.75.99 1.21.26.46.39 1.03.39 1.71 0 1.32-.337 2.31-1.01 2.97-.673.66-1.61.99-2.81.99z",
    style: {
      fill: "url(#g)"
    },
    transform: "matrix(1.26 0 0 1.26 723.18 466.358)",
    fill: "url(#SvgjsLinearGradient2727)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerSecureIllustration);
export default __webpack_public_path__ + "static/media/server-secure-illustration.7acd728ffbc0f8cab22c27e6b945fba4.svg";
export { ForwardRef as ReactComponent };